import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import React, { useRef, useEffect } from 'react';
import configuration from '../../utils/configuration';
import { createNotification } from 'react-redux-notify';

import { getEmail } from '../../helpers/storage/user';
import FileValidator from '../../helpers/validator/file';
import ErrorUtils from '../../helpers/services/communication/error';
import StorageService from '../../helpers/services/communication/storage';
import { getErrorNotificationMessage } from '../../components/helper/NotificationMessage';

const ChatWindowAttachment = ({
  dispatch,
  chatroom,
  isActive,
  setProgress,
  setShowProgress,
  onMediaAttachment,
}) => {
  const fileRef = useRef();

  useEffect(() => {
    if (fileRef.current) {
      fileRef.current.addEventListener(
        'change',
        (event) => {
          handleFileChange(event);
        },
        false,
      );
    }
  }, [fileRef]);

  const onFileClicked = () => {
    fileRef.current.click();
  };

  const handleFileChange = async (event) => {
    if (event.currentTarget.type === 'file') {
      const fileList = Array.from(event.target.files)
      let result = FileValidator.validateMessageFiles(fileList);
      if (!result.status) {
        const notificationMessage = getErrorNotificationMessage(result.message);
        return dispatch(createNotification(notificationMessage));
      }

      uploadSelectedFile(
        `uploads/messages/${getEmail()}/${chatroom}`,
        Array.from(event.currentTarget.files),
      );
    }
  };

  const uploadSelectedFile = async (path, files) => {
    try {
      setProgress(10);
      setShowProgress(true);
      const response = await StorageService.uploadFiles(path, files, (data) => {
        const progress = Math.round((100 * data.loaded) / data.total);
        setProgress(progress === 100 ? 99 : progress);
      });
      if (response.status === 200) {
        onMediaAttachment(response.data.files);
      } else {
        showErrorNotification(response.message || 'File upload failed');
      }
      fileRef.current.value = '';
      setShowProgress(false);
    } catch (error) {
      setShowProgress(false);
      const message = ErrorUtils.parseApiError(error.response)
      if (message.notify) {
        showErrorNotification(message.message);
      }
    }
  };

  const showErrorNotification = (message) => {
    dispatch(createNotification(getErrorNotificationMessage(message)));
  };

  const getValidImageMimes = () => {
    return [
      ...configuration.get('configData.content_image_mime').split(','),
      ...configuration.get('configData.content_video_mime').split(','),
    ]
      .map((mime) => `.${mime}`)
      .join(',');
  };

  return (
    <>
      <input
        multiple
        type='file'
        name='image'
        ref={fileRef}
        style={{ display: 'none' }}
        accept={getValidImageMimes()}
      />
      <button type='button' disabled={!isActive} className='attachmentbtn' onClick={onFileClicked} title='attach'>
        <Image src='https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/attached-icon.svg' round alt='attach icon' />
      </button>
    </>
  );
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(null, mapDispatchToProps)(ChatWindowAttachment);
